import { render, staticRenderFns } from "./WhistleBlower.vue?vue&type=template&id=62154f54&scoped=true&"
import script from "./WhistleBlower.vue?vue&type=script&lang=js&"
export * from "./WhistleBlower.vue?vue&type=script&lang=js&"
import style0 from "./WhistleBlower.vue?vue&type=style&index=0&id=62154f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62154f54",
  null
  
)

export default component.exports